export const access = `{{ env.npm.access ? color.magenta(pkg.private ? 'private' : access) : '' }}`;

export const name = `{{color.bold(name)}} ${access}`;
export const name_inverse = `{{color.level > 0 ? color.inverse.bold(' '+name+' ') : name}} ${access}`;

export const version = `[ {{color.blue(version.type)}} ] \
{{ version.anchor ? color.green(version.anchor) : color.dim('unreleased') }}\
{{ version.pivot && version.pivot !== version.anchor ? ' '+color.green('('+version.pivot+')') : '' }}\
{{ version.type !== 'skip' ? ' → '+color.green(version.next)+' # '+distTag : '' }}`;

export const version_reason = `{% if (!pkg.private) { %}\
{{ h.title('version') }} ${version}
{{ h.title('reason') }} {{ release.reason }}
{% } %}`;

export const change_counts = `{% const chgs = h.chgs.all_counts(); %}\
{{ chgs.length ? chgs : color.dim('none') }}`;

export const change_list = `{{ h.ls(h.chgs.names.map(n => h.chgs.ls(n))) }}`;

export const dep_list = `{%
const dep_list = (l, k) => {
  return Object.keys(l).map(d => dep(d, _.get(anchor, [k,d]), l[d]));
};
const dep = (n, p, v, ps=env.packages, pk=h.pkg(n,ps), c=color.dim) => {
  p = pk && pk.anchor ? '^'+pk.anchor.version : p;
  if (!n || p === v) return;
  return n + ': ' + (p || 'none') + ' → ' + v + (pk && pk.canRelease ? c(' ('+pk.release.type+')') : '');
};
const all_deps = Array.from(new Set([].concat(
  dep_list(dependencies, 'dependencies'),
  dep_list(devDependencies, 'devDependencies'),
  dep_list(optionalDependencies, 'optionalDependencies'),
  dep_list(peerDependencies, 'peerDependencies')
).filter(Boolean)));
%}`;

export const commit_range = `{{ h.commit.hash(anchorCommit) }}\
{{ env.git.head ? '..'+h.commit.hash(env.git.head) : '' }} \
({{ commits.length }})`;

export const commit_list = `{{ h.ls(commits.map(c => h.commit.full(c))) }}`;

export const validations = `{{ h.ls(Array.from(validations.warnings).map(w => color.yellow('WARN')+' '+w)) }}\
{{ h.ls(Array.from(validations.errors).map(w => color.red('ERR!')+' '+w)) }}`;

export const helpers = `{% const h = {
  titleize: (t) => _.words(t).map(s => s[0].toUpperCase()+s.substr(1)).join(" "),
  indent: (s, t='  ') => s.split(/\\r?\\n/g).map(l => t+l).join('\\n'),
  title: (t, c=color.gray) => "  "+c(h.titleize(t)+":"),
  ls: (l, t='    ') => l.map(i => i ? h.indent(i, t)+'\\n' : '').join(''),
  chgs: {
    names: [ 'breaking', 'features', 'fixes', 'chores' ],
    singular: { breaking: 'breaking', features: 'feature', fixes: 'fix', chores: 'chore' },
    count: (k, l=release[k].length) => l ? l+' '+(l === 1 ? h.chgs.singular[k] : k) : '',
    all_counts: () => h.chgs.names.map(n => h.chgs.count(n)).filter(Boolean).join(', '),
    ls: (k, c=color.bold) => release[k].map(i => c(h.chgs.singular[k])+': '+i).join('\\n')
  },
  commit: {
    hash: (c, u=color.underline) => c ? u(c.substr(0, 8)) : '',
    full: (c) => h.commit.hash(c.hash)+' '+c.subject
  },
  pkg: (n, p=env.packages) => p ? p.get(n) : undefined,
  url: (r=_.get(env, "git.remote")) => {
    if (r) return (r.protocol.match(/^http/) ? r.protocol : "https") + '://' +
      r.resource + (r.port ? ':'+r.port : '') + (r.full_name ? '/'+r.full_name : '');
  }
}; %}`;

export const oneline = `${name} ${version}`;
export default oneline;

export const basic = `${helpers}${name_inverse}
${version_reason}\
{{ h.title('commits') }} ${commit_range}
{{ h.title('changes') }} ${change_counts}
`;

export const expanded_changes = `${helpers}${name_inverse}
${version_reason}\
{{ h.title('commits') }} ${commit_range}
{{ h.title('changes') }} ${change_counts}
${change_list}\
`;

export const expanded = `${helpers}${dep_list}${name_inverse}
${version_reason}\
{{ h.title('commits') }} ${commit_range}
${commit_list}\
{% if (env.lerna && all_deps.length) { %}{{ h.title('dependencies') }}\n{{ h.ls(all_deps) }}{% } %}\
{{ h.title('changes') }} ${change_counts}
${change_list}\
{% if (validations.warnings.size || validations.errors.size) { %}\
{{ h.title('problems') }}
${validations}\
{% } %}\
`;

export const changelog_md = `${helpers}{%
const date = DateTime.local().toLocaleString(DateTime.DATE_MED);
const baseUrl = h.url();
const releasePath = (l=location) => '/tree/release/'+env.id+(l ? '/'+path.relative(env.basedir, l) : '');
const urlify = (t, p='', u=baseUrl) => u ? '['+t+']('+u+p+')' : t;
const chglog = (l, t, m) => {
  const rl = (Array.isArray(l) ? l : []).filter(Boolean);
  return rl.length ? '\\n### '+h.titleize(t)+(m ? '\\n'+m : '')+'\\n'+h.ls(rl.map(i => '- '+i), '') : '';
};
const dep_list = (l, k) => {
  return Object.keys(l).map(d => dep(d, _.get(anchor, [k,d]), l[d]));
};
const dep = (n, p, v, ps=env.packages, pk=h.pkg(n,ps)) => {
  p = pk && pk.anchor ? '^'+pk.anchor.version : p;
  if (!n || p === v) return;
  return (pk ? urlify(n, releasePath(pk.location)) : n) + ': ' + (p ? '\`'+p+'\`' : 'none') + ' → \`' + v + '\`';
};
const all_deps = new Set([].concat(
  dep_list(dependencies, 'dependencies'),
  dep_list(devDependencies, 'devDependencies'),
  dep_list(optionalDependencies, 'optionalDependencies'),
  dep_list(peerDependencies, 'peerDependencies')
));
const commit_range = (s=false, a=anchorCommit, h=_.get(env, "git.head")) => {
  return (a ? s ? a.substr(0, 8) : a : '') + (h ? '..'+(s ? h.substr(0, 8) : h) : '');
};
const commit_list = commits.map(c => '- '+urlify('\`'+c.hash.substr(0,8)+'\`', '/commit/'+c.hash)+' '+c.subject);
%}\
## {{ urlify(version.next, releasePath()) }} - {{ date }}
{{ chglog(release.breaking, 'breaking') }}\
{{ chglog(release.features, 'features') }}\
{{ chglog(release.fixes, 'fixes') }}\
{{ chglog(release.chores, 'chores') }}\
{{ chglog(Array.from(all_deps), 'dependencies') }}\

### Commits
{{ urlify('\`'+commit_range(true)+'\`', '/compare/'+commit_range()) }}
{{ h.ls(commit_list, '') }}\
`;
